import Icon from '@components/UI/Icon';
import css from '@utils/css'
import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

const Input = forwardRef(({
    mods={},
    type='text',
    name,
    id,
    value,
    placeholder,
    cols,
    rows,
    autoComplete,
    disabled=false,
    required=false,
    search,
    searchIcon,
    inputProps,
    onChange,
    onClick,
    onFocus,
    onBlur,
    onKeyDown,
    className: classNameTail
}, ref) => {
    const { className } = useMods(Input, { mods: { ...mods, search } });

    const cn = css(className, classNameTail)

    return (
        type == 'textarea' ?
            <textarea
                name={ name }
                className={ cn }
                id={ id }
                ref={ ref }
                cols={ cols }
                rows={ rows }
                placeholder={ placeholder }
                required={ required }
                disabled={ disabled }
                { ...inputProps }
                onChange={ onChange }
                value = { value }
            /> :
            (
                <>
                    <input
                        ref={ ref }
                        type={ type }
                        name={ name }
                        className={ cn }
                        id={ id }
                        value={ value }
                        autoComplete={ autoComplete }
                        placeholder={ placeholder }
                        required={ required }
                        disabled={ disabled }
                        { ...inputProps }
                        onChange={ onChange }
                        onClick={ onClick }
                        onFocus={ onFocus }
                        onBlur={ onBlur }
                        onKeyDown={ onKeyDown }
                    />
                    { searchIcon && <Icon
                        name='search'
                        color='#6E7278'
                        size={ 16 }
                    /> }
                </>
            )
    );
});

Input.displayName = 'Input';

Input.propTypes = {
    autoComplete: PropTypes.string,
    cols: PropTypes.number,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    mods: PropTypes.object,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    rows: PropTypes.number,
    search: PropTypes.bool,
    searchIcon: PropTypes.bool,
    type: PropTypes.string.isRequired,
    value: PropTypes.any
};

export default Input;
